import * as React from 'react';
import { AdditionalCriteriaType } from 'app/pages/DiscountEditor/actionTypes';
import { ProductFilter, getProductType, ProductFilterType, getSelectedProductCodes } from 'app/shared/model/ProductFilter';
import { EmptyCriteria } from 'app/pages/DiscountEditor/modules/AdditionalCriteria';
import { ProductFilterSection } from 'app/pages/DiscountEditor/modules/AdditionalCriteria/state';
import ConnectedProductSelectionDisplay from 'app/pages/DiscountEditor/components/ConnectedProductSelectionDisplay';
import { getProductTypeDisplayName } from 'app/shared/model';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface ProductCriteriaDisplayProps {
    onEdit: (type: AdditionalCriteriaType) => void
    onDelete: (type: AdditionalCriteriaType) => void
    courseCriteria: ProductFilterSection|EmptyCriteria
    accommodationCriteria: ProductFilterSection|EmptyCriteria
    addOnCriteria: ProductFilterSection|EmptyCriteria
    transferCriteria: ProductFilterSection|EmptyCriteria
}

interface ProductSectionCriteriaProps {
    onEdit: () => void
    onDelete: () => void
    criteria: ProductFilterSection|EmptyCriteria
}

function ProductSectionCriteria(props: ProductSectionCriteriaProps) {
    if (!props.criteria.hasCriteria)
        return <div></div>;

    const productType = getProductType(props.criteria.productFilter);
    const productTypeName = productType ? getProductTypeDisplayName(productType) : '';
    
    return <div style={{ marginBottom: 16 }}>
        <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 14 }}>{productTypeName}</div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ flex: 1 }}>
                <ConnectedProductSelectionDisplay 
                    productFilter={props.criteria.productFilter} 
                    unitsFilter={props.criteria.unitsFilter}
                />
            </div>
            <div style={{ display: 'flex', gap: 4 }}>
                <Button 
                    type="text"
                    icon={<DeleteOutlined />}
                    onClick={() => props.onDelete()}
                    style={{ padding: '4px 8px' }}
                />
                <Button 
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => props.onEdit()}
                    style={{ padding: '4px 8px' }}
                />
            </div>
        </div>
    </div>;
}

export default function ProductCriteriaDisplay(props: ProductCriteriaDisplayProps) {
    return <div>
        <ProductSectionCriteria 
            criteria={props.courseCriteria} 
            onDelete={() => props.onDelete(AdditionalCriteriaType.Course)}
            onEdit={() => props.onEdit(AdditionalCriteriaType.Course)} />

        <ProductSectionCriteria 
            criteria={props.accommodationCriteria}
            onDelete={() => props.onDelete(AdditionalCriteriaType.Accommodation)}
            onEdit={() => props.onEdit(AdditionalCriteriaType.Accommodation)} />

        <ProductSectionCriteria 
            criteria={props.addOnCriteria}
            onDelete={() => props.onDelete(AdditionalCriteriaType.AddOns)}
            onEdit={() => props.onEdit(AdditionalCriteriaType.AddOns)} />

        <ProductSectionCriteria 
            criteria={props.transferCriteria}
            onDelete={() => props.onDelete(AdditionalCriteriaType.Transfer)}
            onEdit={() => props.onEdit(AdditionalCriteriaType.Transfer)} />
    </div>;
}